import { t } from 'i18next';

import { formatNumberWithFractionDigits } from '~/helpers/thousandFormatNumber';

import { DONUT_TOP_N } from '../../config';
import { ChartDatum, DonutItem, DonutUnit } from './types';

export function aggregateTopN(items: DonutItem[]): ChartDatum[] {
  if (items.length <= DONUT_TOP_N) {
    return items.map((i) => ({ name: i.name, value: i.value, percentage: i.percentage }));
  }
  const top = items.slice(0, DONUT_TOP_N);
  const rest = items.slice(DONUT_TOP_N);
  const restValue = rest.reduce((acc, i) => acc + i.value, 0);
  const restPercentage = rest.reduce((acc, i) => acc + i.percentage, 0);
  return [
    ...top.map((i) => ({ name: i.name, value: i.value, percentage: i.percentage })),
    { name: t('outros'), value: restValue, percentage: restPercentage },
  ];
}

export function formatValue(value: number, unit: DonutUnit): string {
  if (unit === 'capacity') {
    return `${formatNumberWithFractionDigits(value, { minimum: 1, maximum: 1 })} TR`;
  }
  return formatNumberWithFractionDigits(value, { minimum: 0, maximum: 0 });
}

export function formatPercent(value: number): string {
  if (value >= 1) {
    return formatNumberWithFractionDigits(value, { minimum: 0, maximum: 0 });
  }
  if (value > 0 && value < 0.1) {
    return `< ${formatNumberWithFractionDigits(0.1, { minimum: 1, maximum: 1 })}`;
  }
  return formatNumberWithFractionDigits(value, { minimum: 1, maximum: 1 });
}
